import React, { createContext, useContext, useMemo, useState, useCallback } from 'react';
import { getStoredTemplateId, getTemplateById, UI_TEMPLATES } from '../constants/branding';

const ThemeTemplateContext = createContext({
  template: getTemplateById('amber-night'),
  templateId: 'amber-night',
  templates: UI_TEMPLATES,
  setTemplateId: () => {}
});

export const useThemeTemplate = () => useContext(ThemeTemplateContext);

export const ThemeTemplateProvider = ({ children }) => {
  const [templateId, setTemplateIdState] = useState(getStoredTemplateId);

  const setTemplateId = useCallback((id) => {
    localStorage.setItem('tenanthub_ui_template', id);
    setTemplateIdState(id);
  }, []);

  const value = useMemo(() => ({
    template: getTemplateById(templateId),
    templateId,
    templates: UI_TEMPLATES,
    setTemplateId
  }), [templateId, setTemplateId]);

  return (
    <ThemeTemplateContext.Provider value={value}>
      {children}
    </ThemeTemplateContext.Provider>
  );
};
